import copy from 'copy-to-clipboard';
import angular from 'angular';

angular.module('cloudX').component('copyToClipboard', {
  template: `<a ng-click="$ctrl.copy()" title="{{('CopyToClipboard'|translate)}}" ng-show="$ctrl.value"><i class="fa fa-clipboard"></a>`,
  bindings: {
    value: '<',
  },
  controller: [
    'flySvc',
    function(flySvc) {
      const ctrl = this;
      ctrl.copy = () => {
        if (!ctrl.value) return;
        if (copy(ctrl.value)) {
          flySvc.success('ValueCopiedToClipboard');
        }
      };
    },
  ],
});
